import { GetCommentListByPostIdQuery_getCommentListByPostId_comments, IWithCommentVoteChange, withCommentVoteChange } from "@bakbak/controller";
import * as React from 'react';
import * as isEqual from "react-fast-compare";
import { AppContextProps, withAppContext } from '../../../context/AppContext';
import { CommentItemView } from './CommentItemView';


interface Props {
  comment: GetCommentListByPostIdQuery_getCommentListByPostId_comments;
}

class CommentItemC extends React.Component<Props & IWithCommentVoteChange & AppContextProps> {

  shouldComponentUpdate(nextProps: Props & AppContextProps) {
    return !(
      isEqual(this.props.context.loggedUser, nextProps.context.loggedUser)
      && isEqual(this.props.comment, nextProps.comment)
    )
  }

  changeVote = async (likeDislike: number) => {
    const { commentVoteChange, comment } = this.props;
    const response = await commentVoteChange({ commentId: comment.id, likeDislike });
    if (response === null) {
      // TODO: Log this error.
      console.log('some error occured. Log it properly', response);
    } else if (response.errors) {
      console.log('some error occured. Log it properly', response.errors);
    } else if (response.comment) {
      // Nothing to do here
    }
  }

  render() {
    return (
      <CommentItemView
        comment={this.props.comment}
        changeVote={this.changeVote}
        loggedUser={this.props.context.loggedUser}
      />
    );
  }
}

export const CommentItemConnector = withAppContext(withCommentVoteChange(CommentItemC));



// WEBPACK FOOTER //
// ./src/modules/comment/item/CommentItemConnector.tsx